import {CheckboxKind, CheckboxState} from './types';
import {ThemeColorName} from '../../theme';
import {ThemeBorderWidthNames} from '../../theme/types/ThemeBorder';

export const CheckmarkStyleMap: {
  [key in CheckboxKind]: {
    [key in CheckboxState]: {
      backgroundColor: ThemeColorName;
      borderColor?: ThemeColorName;
      borderWidth?: keyof ThemeBorderWidthNames;
      borderStyle?: 'solid';
    };
  };
} = {
  Default: {
    Checked: {
      backgroundColor: 'background_mono_inverse_primary',
    },
    Indetermined: {
      backgroundColor: 'background_mono_inverse_primary',
    },
    NotChecked: {
      backgroundColor: 'background_mono_primary',
      borderColor: 'border_mono_30',
      borderWidth: '1',
      borderStyle: 'solid',
    },
  },
  Disabled: {
    Checked: {
      backgroundColor: 'background_mono_inverse_disabled',
    },
    Indetermined: {
      backgroundColor: 'background_mono_inverse_disabled',
    },
    NotChecked: {
      backgroundColor: 'background_mono_primary',
      borderColor: 'border_mono_10',
      borderWidth: '1',
      borderStyle: 'solid',
    },
  },
  Error: {
    Checked: {
      backgroundColor: 'background_negative_default',
    },
    Indetermined: {
      backgroundColor: 'background_negative_default',
    },
    NotChecked: {
      backgroundColor: 'background_mono_primary',
      borderColor: 'border_negative_default',
      borderWidth: '1',
      borderStyle: 'solid',
    },
  },
  Success: {
    Checked: {
      backgroundColor: 'background_positive_default',
    },
    Indetermined: {
      backgroundColor: 'background_positive_default',
    },
    NotChecked: {
      backgroundColor: 'background_mono_primary',
      borderColor: 'border_positive_default',
      borderWidth: '1',
      borderStyle: 'solid',
    },
  },
};
